// extracted by mini-css-extract-plugin
export default {"layout":"styles_layout__yl8s4","container":"styles_container__pYgCg","footer":"styles_footer__2Nt70"};